export function serialize(record) {
  return JSON.stringify(record);
}

export function deserialize(json) {
  const {
    id,
    parent,
    code,
    description,
    from_date,
    to_date,
    iscode,
    level,
    etsng_class,
    gng_code,
    min_weight
  } = json;

  return {
    id,
    parentId: parent,
    code,
    description,
    fromDate: from_date,
    toDate: to_date,
    iscode,
    level,
    etsngClass: etsng_class,
    gngCode: gng_code,
    minWeight: min_weight
  };
}



// WEBPACK FOOTER //
// ./src/serializers/EtsngNode.js